import { api } from "@lumberset/api-client";
import { HelpContact, requestReportProblem } from "@lumberset/support-ui";
import { Container, SectionHeader } from "@lumberset/ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/help/contact")({ component: ContactPage });

function ContactPage() {
  return (
    <Container className="divide-y p-0">
      <SectionHeader
        level="h1"
        title="Reach a person"
        description="Open a ticket, ask for a call, or email us. Support answers by email."
      />
      <div className="px-6 py-5">
        <div className="mx-auto w-full max-w-3xl">
          {/* The shell's report form, which takes a screenshot of the page, is how a ticket is opened. */}
          <HelpContact api={api} onOpenTicket={requestReportProblem} />
        </div>
      </div>
    </Container>
  );
}
